export const PUBLIC_ASSETS = Object.freeze({
  gcalIcon: "/img/google-calendar/gcal-icon.png",
} as const);
